import(/* webpackMode: "eager", webpackExports: ["HeroContent"] */ "/vercel/path0/components/home/HeroContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectsExplorer"] */ "/vercel/path0/components/projects/ProjectsExplorer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/ScrollReveal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
